import { combineReducers } from 'redux';
import {
  START_OR_RESUME_SURVEY_SUCCESS,
  COMMIT_QUESTION_BLOCK_SUCCESS,
  GET_BLOCK_SUCCESS,
} from 'actionTypes';
import { byIdReducerTemplate, allIdsReducerTemplate } from '../reducerUtils';

export default combineReducers({
  byId: byIdReducerTemplate('questionBlocks'),
  allIds: allIdsReducerTemplate([
    START_OR_RESUME_SURVEY_SUCCESS,
    COMMIT_QUESTION_BLOCK_SUCCESS,
    GET_BLOCK_SUCCESS,
  ]),
});



// WEBPACK FOOTER //
// ./src/reducers/entities/questionBlocksReducer.js